module.exports = __webpack_public_path__ + "img/xbj-02.2034b64d.svg";